import CartTypes from "./cart.types";

const INITIAL_STATE = {
    productFor: 'inner',
    installation: true,
    price: 0,
    portal: 1
};

const CartReducer = (state= INITIAL_STATE, action) => {
    switch (action.type) {
        case CartTypes.SET_INTERNAL_EXTERNAL:
            return{
                ...state,
                productFor: action.payload
            };
        case CartTypes.SET_INTSTALLATION:
            return{
                ...state,
                installation: action.payload
            };
        case CartTypes.SET_PRICE:
            return{
                ...state,
                price: action.payload
            };
        case CartTypes.CHANGE_PORTAL:
            return{
                ...state,
                portal: action.payload
            };
        default :
            return state
    }
};

export default CartReducer